import React, { useState, useEffect } from 'react';
import { 
  Card, Box, Typography, CircularProgress, Accordion, AccordionSummary, AccordionDetails 
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SchoolIcon from '@mui/icons-material/School';

// Button style for links
const buttonStyle = {
  display: 'inline-block',
  backgroundColor: '#0074e4',
  color: 'white',
  padding: '8px 16px',
  borderRadius: '5px',
  textDecoration: 'none',
  fontWeight: 'bold',
  textAlign: 'center',
};

const getRatingColor = (rating) => {
  if (!rating || rating === '') return 'gray';
  const lowerRating = rating.toLowerCase();
  if (lowerRating.includes('above')) return 'green';
  if (lowerRating.includes('below')) return 'red';
  if (lowerRating.includes('average')) return 'blue';
  return 'blue';
};

const SchoolListCard = ({ schools = [] }) => {
    return (
      <Card
        sx={{
          width: 765, // Fixed width to match other cards
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '20px',
          boxShadow: 3,
          maxHeight: '500px', // Limits height so the list becomes scrollable
          overflowY: 'auto',
        }}
      >
        <p style={{ marginLeft: '15px', marginBottom: '10px', marginTop: '0px' }}>
          <span style={{ fontWeight: "600" }}>Nearby Schools</span>
        </p>
        {schools.map((school) => (
          <Accordion 
            key={school['universal-id']} 
            sx={{
              marginBottom: 1,  
              borderRadius: '10px', 
              boxShadow: 'none',
              border: 'none'
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <SchoolIcon color="primary" />
                <Typography variant="h7" sx={{ ml: 2, flexGrow: 1 }}>
                  {school.name}
                </Typography>
                {(school.rating_band && school.rating_band.toLowerCase() !== 'null') && (
                  <Typography 
                    variant="body1" 
                    sx={{ fontWeight: '600', color: getRatingColor(school.rating_band) }}
                  >
                    {school.rating_band}
                  </Typography>
                )}
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Typography variant="body2" sx={{ mb: 1 }}>
                {school['school-summary']}
              </Typography>
              <Typography variant="body2">
                <strong>Address:</strong> {school.street}, {school.city}, {school.state} {school.zip}
              </Typography>
              {school.phone && (
                <Typography variant="body2">
                  <strong>Phone:</strong> {school.phone}
                </Typography>
              )}
              {school.level && (
                <Typography variant="body2">
                  <strong>Level:</strong> {school.level}
                </Typography>
              )}
              {school['district-name'] && (
                <Typography variant="body2">
                  <strong>District:</strong> {school['district-name']}
                </Typography>
              )}
              <Typography variant="body2">
                <strong>Distance:</strong> {school.distance.toFixed(2)} miles
              </Typography>
              <Box sx={{ mt: 1 }}>
                {school['web-site'] && (
                  <a
                    href={school['web-site']}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={buttonStyle}
                  >
                    Visit Website
                  </a>
                )}
                {school['overview-url'] && (
                  <a
                    href={school['overview-url']}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ ...buttonStyle, marginLeft: '16px' }}
                  >
                    More Info
                  </a>
                )}
              </Box>
            </AccordionDetails>
          </Accordion>
        ))}
      </Card>
    );
  };
  

const SchoolCardPage = ({ lat, lon }) => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch nearby schools using your API key and the provided latitude and longitude.
    const fetchSchools = async () => {
      try {
        const response = await fetch(
          `https://gs-api.greatschools.org/v2/nearby-schools?lat=${lat}&lon=${lon}&limit=50&distance=5`,
          {
            headers: {
              Accept: 'application/json',
              'X-API-Key': 'FWlzb14SJaago9rYaaOCaEvYTTLXkLJ7EbJmqhXd',
            },
          }
        );
        const data = await response.json();
        setSchools(data.schools);
      } catch (error) {
        console.error('Error fetching schools:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSchools();
  }, [lat, lon]);

  return (
    <Box sx={{ width: 765, marginBottom: 3 }}>
      {loading ? <CircularProgress /> : <SchoolListCard schools={schools} />}
    </Box>
  );
};

export default SchoolCardPage;
